(function () {
  var MOBILE_RAIL_QUERY = window.matchMedia('(max-width: 798px)');

  function initRails(root) {
    root.querySelectorAll('[data-bh-rail]').forEach(function (rail) {
      if (rail.dataset.bhRailInit === 'true') return;
      if (!rail.querySelector('[data-bh-rail-page]')) return;
      rail.dataset.bhRailInit = 'true';

      var prevButtons = rail.querySelectorAll('[data-bh-rail-prev]');
      var nextButtons = rail.querySelectorAll('[data-bh-rail-next]');
      var desktopGrids = rail.querySelector('[data-bh-rail-grids-desktop]');
      var mobileGrids = rail.querySelector('[data-bh-rail-grids-mobile]');
      var desktopDotsWrap = rail.querySelector('[data-bh-rail-dots="desktop"]');
      var mobileDotsWrap = rail.querySelector('[data-bh-rail-dots="mobile"]');
      var hasDualView = !!(mobileGrids && desktopGrids);
      var pages = [];
      var dots = [];
      var pageIndex = 0;
      var scrollContainer = null;
      var scrollRaf = null;

      function usesMobileView() {
        return hasDualView && MOBILE_RAIL_QUERY.matches;
      }

      function usesScrollPager() {
        if (!MOBILE_RAIL_QUERY.matches || pages.length <= 1) return false;
        if (rail.id === 'bh-favorites' && usesMobileView()) return true;
        if (rail.id === 'bh-swim-rail') return true;
        return false;
      }

      function getScrollContainer() {
        if (!usesScrollPager()) return null;
        if (usesMobileView() && mobileGrids) return mobileGrids;
        if (rail.id === 'bh-swim-rail') {
          var swimGrids = rail.querySelector('.bh-swim__rail-viewport [data-bh-rail-grids]');
          return swimGrids || null;
        }
        return null;
      }

      function scrollToPage(index, behavior) {
        var container = getScrollContainer();
        if (!container || !pages[index]) return;
        container.scrollTo({
          left: pages[index].offsetLeft,
          behavior: behavior || 'smooth',
        });
      }

      function syncPageFromScroll() {
        var container = getScrollContainer();
        if (!container || !pages.length) return;
        var width = container.clientWidth;
        if (!width) return;
        var nextIndex = Math.round(container.scrollLeft / width);
        nextIndex = Math.max(0, Math.min(nextIndex, pages.length - 1));
        if (nextIndex === pageIndex) return;
        pageIndex = nextIndex;
        syncNavButtons(pageIndex === 0, pageIndex === pages.length - 1);
        syncDots(pageIndex);
      }

      function onScrollContainerScroll() {
        if (!usesScrollPager()) return;
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(syncPageFromScroll);
      }

      function activateView() {
        var mobile = usesMobileView();
        var pager = rail.querySelector('[data-bh-rail-pager]');

        if (desktopGrids) desktopGrids.hidden = mobile;
        if (mobileGrids) mobileGrids.hidden = !mobile;
        if (desktopDotsWrap) desktopDotsWrap.hidden = mobile;
        if (mobileDotsWrap) mobileDotsWrap.hidden = !mobile;

        if (mobile && mobileGrids) {
          pages = Array.prototype.slice.call(mobileGrids.querySelectorAll('[data-bh-rail-page]'));
          dots = mobileDotsWrap
            ? Array.prototype.slice.call(mobileDotsWrap.querySelectorAll('[data-bh-rail-dot]'))
            : [];
        } else if (desktopGrids) {
          pages = Array.prototype.slice.call(desktopGrids.querySelectorAll('[data-bh-rail-page]'));
          dots = desktopDotsWrap
            ? Array.prototype.slice.call(desktopDotsWrap.querySelectorAll('[data-bh-rail-dot]'))
            : [];
        } else {
          pages = Array.prototype.slice.call(rail.querySelectorAll('[data-bh-rail-page]'));
          dots = Array.prototype.slice.call(rail.querySelectorAll('[data-bh-rail-dot]'));
        }

        if (pager) {
          pager.hidden = pages.length <= 1;
        }

        if (pageIndex >= pages.length) {
          pageIndex = 0;
        }
      }

      function syncDots(activeIndex) {
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function syncNavButtons(isPrevDisabled, isNextDisabled) {
        prevButtons.forEach(function (button) {
          button.disabled = isPrevDisabled;
        });
        nextButtons.forEach(function (button) {
          button.disabled = isNextDisabled;
        });
      }

      function showPage(i, scrollBehavior) {
        if (!pages.length) return;
        pageIndex = Math.max(0, Math.min(i, pages.length - 1));

        if (usesScrollPager()) {
          scrollToPage(pageIndex, scrollBehavior || 'smooth');
        } else {
          pages.forEach(function (page, pageNumber) {
            page.setAttribute('data-visible', pageNumber === pageIndex ? 'true' : 'false');
          });
        }

        syncNavButtons(pageIndex === 0, pageIndex === pages.length - 1);
        syncDots(pageIndex);
      }

      prevButtons.forEach(function (prev) {
        prev.addEventListener('click', function () {
          showPage(pageIndex - 1);
        });
      });

      nextButtons.forEach(function (next) {
        next.addEventListener('click', function () {
          showPage(pageIndex + 1);
        });
      });

      rail.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-bh-rail-dot]');
        if (!dot || !rail.contains(dot)) return;
        if (dot.closest('[hidden]')) return;
        var targetPage = parseInt(dot.getAttribute('data-page'), 10);
        if (isNaN(targetPage)) return;
        showPage(targetPage);
      });

      function handleViewChange() {
        var previousPage = pageIndex;
        var previousContainer = scrollContainer;
        if (previousContainer) {
          previousContainer.removeEventListener('scroll', onScrollContainerScroll);
        }

        activateView();
        showPage(Math.min(previousPage, Math.max(pages.length - 1, 0)), 'auto');

        scrollContainer = getScrollContainer();
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', onScrollContainerScroll, { passive: true });
        }
      }

      MOBILE_RAIL_QUERY.addEventListener('change', handleViewChange);
      activateView();
      scrollContainer = getScrollContainer();
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', onScrollContainerScroll, { passive: true });
      }
      showPage(0, 'auto');
    });
  }

  function initTestimonials(root) {
    var wrap = root.querySelector('[data-bh-testimonials]');
    if (!wrap || wrap.dataset.bhTestimonialsInit === 'true') return;
    wrap.dataset.bhTestimonialsInit = 'true';

    var quotes = wrap.querySelectorAll('[data-bh-review]');
    var avatars = wrap.querySelectorAll('[data-bh-review-avatar]');
    var prev = wrap.querySelector('[data-bh-review-prev]');
    var next = wrap.querySelector('[data-bh-review-next]');
    if (!quotes.length) return;

    var index = 0;
    var paused = false;
    var timer;

    function syncAvatarMeta(activeIndex) {
      avatars.forEach(function (avatar, avatarIndex) {
        var meta = avatar.querySelector('.bh-reviews__avatar-meta');
        if (avatarIndex === activeIndex) {
          var name = quotes[activeIndex].getAttribute('data-review-name') || '';
          var role = quotes[activeIndex].getAttribute('data-review-role') || '';
          if (!meta && name) {
            meta = document.createElement('span');
            meta.className = 'bh-reviews__avatar-meta';
            var nameEl = document.createElement('strong');
            var roleEl = document.createElement('span');
            roleEl.className = 'bh-reviews__avatar-role';
            meta.appendChild(nameEl);
            meta.appendChild(roleEl);
            avatar.appendChild(meta);
          }
          if (meta) {
            var strong = meta.querySelector('strong');
            var roleNode = meta.querySelector('.bh-reviews__avatar-role');
            if (strong) strong.textContent = name;
            if (roleNode) roleNode.textContent = role;
          }
          avatar.setAttribute('aria-current', 'true');
        } else {
          if (meta) meta.remove();
          avatar.removeAttribute('aria-current');
        }
      });
    }

    function show(i) {
      index = (i + quotes.length) % quotes.length;
      quotes.forEach(function (quote, quoteIndex) {
        quote.classList.toggle('is-active', quoteIndex === index);
      });
      avatars.forEach(function (avatar, avatarIndex) {
        avatar.classList.toggle('is-active', avatarIndex === index);
      });
      syncAvatarMeta(index);
    }

    function go(delta) {
      show(index + delta);
      resetTimer();
    }

    function resetTimer() {
      clearInterval(timer);
      if (quotes.length < 2 || paused) return;
      timer = setInterval(function () { show(index + 1); }, 7000);
    }

    avatars.forEach(function (avatar, avatarIndex) {
      avatar.addEventListener('click', function () {
        show(avatarIndex);
        resetTimer();
      });
    });
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    wrap.addEventListener('mouseenter', function () { paused = true; clearInterval(timer); });
    wrap.addEventListener('mouseleave', function () { paused = false; resetTimer(); });

    show(0);
    resetTimer();
  }

  function setFaqItemState(item, isOpen) {
    var trigger = item.querySelector('[data-bh-faq-trigger]');
    item.classList.toggle('is-open', isOpen);
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function initFaq(root) {
    if (root.dataset.bhFaqInit === 'true') return;

    var list = root.querySelector('.bh-faq__list');
    if (!list) return;

    root.dataset.bhFaqInit = 'true';

    list.querySelectorAll('.bh-faq__icon').forEach(function (icon) {
      icon.textContent = '';
    });

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bh-faq-trigger]');
      if (!trigger || !list.contains(trigger)) return;

      var item = trigger.closest('[data-bh-faq-item]');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');
      root.querySelectorAll('[data-bh-faq-item]').forEach(function (other) {
        setFaqItemState(other, false);
      });
      if (!isOpen) setFaqItemState(item, true);
    });

    var first = root.querySelector('[data-bh-faq-item]');
    if (first) setFaqItemState(first, true);
  }

  function updateHeaderCartCount() {
    if (window.jQuery && window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart) {
      try {
        Shopify.theme.jsAjaxCart.updateView();
        return Promise.resolve();
      } catch (error) {
        /* fall through to fetch fallback */
      }
    }

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) {
          el.classList.toggle('has-cart-count', cart.item_count > 0);
        });
      });
  }

  function initSwimAddToCart(root) {
    root.querySelectorAll('#bh-swim-rail [data-bh-swim-atc]').forEach(function (form) {
      if (form.dataset.bhSwimAtcInit === 'true') return;
      form.dataset.bhSwimAtcInit = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector('[data-bh-add-to-cart]');
        var variantId = button && button.getAttribute('data-variant-id');
        if (!variantId || !button || button.disabled) return;

        var productUrl = button.getAttribute('data-product-url') || '/cart';
        var label = button.textContent.trim();
        button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (payload) {
                throw new Error(payload && payload.description ? payload.description : 'Unable to add item');
              });
            }
            return response.json();
          })
          .then(function () {
            return updateHeaderCartCount();
          })
          .then(function () {
            button.disabled = false;
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = label;
            window.location.href = productUrl;
          });
      });
    });
  }

  function clearRootInitFlags(root) {
    root.removeAttribute('data-bh-faq-init');
    root.removeAttribute('data-bh-testimonials-init');
    root.querySelectorAll('[data-bh-rail]').forEach(function (rail) {
      rail.removeAttribute('data-bh-rail-init');
    });
    root.querySelectorAll('[data-bh-swim-atc]').forEach(function (form) {
      form.removeAttribute('data-bh-swim-atc-init');
    });
  }

  function initRoot(root) {
    initRails(root);
    initTestimonials(root);
    initFaq(root);
    initSwimAddToCart(root);
  }

  function boot() {
    document.querySelectorAll('.breakout-home').forEach(initRoot);
  }

  function handleSectionLoad(event) {
    var section = event.target;
    if (!section) return;

    var root = section.querySelector('.breakout-home');
    if (!root) return;

    clearRootInitFlags(root);
    initRoot(root);
  }

  if (!window.__breakoutHomepageBound) {
    window.__breakoutHomepageBound = true;
    document.addEventListener('shopify:section:load', handleSectionLoad);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  } else {
    boot();
  }
})();
